// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";

function PlAltRanks(Props) {
  var hrRank = Props.hrRank;
  var duoRank = Props.duoRank;
  var basePath = CdnAtom.usePath4(undefined);
  var tmp;
  if (duoRank !== undefined) {
    var tier = duoRank[1];
    var league = Belt_Array.getExn(tier.split(" "), 0).toLowerCase();
    tmp = React.createElement("div", {
          className: "relative overflow-hidden flex flex-col items-center bg-bg0 py-[10px] rounded w-[160px] lg:w-[172px] h-[60px]",
          style: Global.s({
                textShadow: "-1px 0 2px rgba(0, 0, 0, 0.2), 0 1px 2px rgba(0, 0, 0, 0.2), 1px 0 2px rgba(0, 0, 0, 0.2), 0 -1px 2px rgba(0, 0, 0, 0.2)"
              })
        }, React.createElement("div", {
              className: CssJs.merge([
                    "absolute z-0 top-[-12px] left-[-40px] w-[86px] h-[86px] rounded",
                    CssJs.style([
                          CssJs.unsafe("backgroundImage", "url(" + basePath + "/banner/" + league + "_solo.png?w=86)"),
                          CssJs.unsafe("maskImage", "linear-gradient(to right, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.9) 40%, rgba(0, 0, 0, 0.6) 65%, rgba(0, 0, 0, 0.05))"),
                          CssJs.unsafe("backgroundSize", "86px")
                        ])
                  ])
            }), React.createElement("div", {
              className: "z-10 flex items-center font-medium pb-2 leading-none text-[16px] font-montserrat"
            }, React.createElement("div", {
                  className: "flex items-center"
                }, React.createElement("div", undefined, LpChartUtils.renderDivisionName(tier) + " " + String(duoRank[2]) + "LP"))), React.createElement("div", {
              className: " font-montserrat z-10 text-[14px]"
            }, "Double Up"));
  } else {
    tmp = null;
  }
  var tmp$1;
  if (hrRank !== undefined) {
    var tier$1 = hrRank[1];
    tmp$1 = React.createElement("div", {
          className: "relative overflow-hidden flex flex-col items-center bg-bg0 p-[10px] rounded w-[160px] lg:w-[172px] h-[60px]",
          style: Global.s({
                textShadow: "-1px 0 2px rgba(0, 0, 0, 0.2), 0 1px 2px rgba(0, 0, 0, 0.2), 1px 0 2px rgba(0, 0, 0, 0.2), 0 -1px 2px rgba(0, 0, 0, 0.2)"
              })
        }, React.createElement("div", {
              className: CssJs.merge([
                    "absolute z-0 top-[-1px] left-[-28px] w-[66px] h-[66px] rounded",
                    CssJs.style([
                          CssJs.unsafe("backgroundImage", "url(" + basePath + "/banner/badge_" + tier$1.toLowerCase() + ".png?w=66)"),
                          CssJs.unsafe("maskImage", "linear-gradient(to right, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.85) 40%, rgba(0, 0, 0, 0.55) 70%, rgba(0, 0, 0, 0.05))"),
                          CssJs.unsafe("backgroundSize", "66px"),
                          CssJs.unsafe("backgroundPosition", "center")
                        ])
                  ])
            }), React.createElement("div", {
              className: "z-10 flex items-center font-medium pb-2 leading-none text-[16px] font-montserrat"
            }, React.createElement("div", {
                  className: "flex items-center"
                }, React.createElement("div", undefined, LpChartUtils.renderDivisionName(tier$1) + " " + String(hrRank[2]) + "LP"))), React.createElement("div", {
              className: " font-montserrat z-10 text-[14px]"
            }, "Hyperroll"));
  } else {
    tmp$1 = null;
  }
  return React.createElement("div", {
              className: "flex gap-4 lg:gap-3 justify-center lg:flex-col lg:justify-start"
            }, tmp, tmp$1);
}

var make = PlAltRanks;

export {
  make ,
  
}
/* CssJs Not a pure module */
